import React from "react"
import { FiPlayCircle } from "react-icons/fi"

const ImagesRow = ({ data, handleImage, video }) => {
  return (
    <div className="flex md:flex-col justify-start items-center overflow-x-auto gap-4 w-full h-full max-w-xs md:max-w-24 md:max-h-[370px] pb-3">
      {video?.length ? (
        <div className="w-full h-full max-h-20 min-h-[80px] flex justify-center items-center bg-[url('assets/images/background.jpg')] bg-cover bg-center rounded-lg">
          <button
            className="flex justify-center items-center cursor-pointer w-full h-full min-w-[104px] rounded-lg backdrop-blur-md"
            onClick={() => handleImage({}, "video")}
          >
            <FiPlayCircle size={24} color="white" />
          </button>
        </div>
      ) : null}
      {data.map((item) => (
        <button
          className="w-full h-full "
          key={item?.image}
          onClick={() => handleImage(item, "image")}
        >
          <img
            src={item?.image}
            alt={`thumb__${item?.image}`}
            className="bg-cover max-h-20 cursor-pointer w-full h-full min-w-[104px] rounded-lg object-fill"
            loading="lazy"
          />
        </button>
      ))}
    </div>
  )
}

export default ImagesRow
